<script setup lang="ts">
    import IconButton from '../IconButton.vue';
    import { __ } from '@/js/stores/expressions';
    import { FavoriteFilterList } from '@/js/services/api/filter/types';
    import EchoButton from '../EchoButton.vue';
    import { XIcon } from '@lucide/vue';

    defineProps<{
        list: FavoriteFilterList;
    }>();

    defineEmits<{
        (e: 'select', filter: { id: string; name: string }): void;
        (e: 'delete', filter: { id: string; name: string }): void;
    }>();
</script>
<template>
    <div
        v-for="filter in list"
        :key="filter.id"
        class="flex w-full relative items-center group max-w-64"
    >
        <div class="grow">
            <EchoButton variant="block" @click="$emit('select', filter)">
                <div class="whitespace-normal text-left -mr-6">
                    {{ filter.name }}
                </div>
            </EchoButton>
        </div>
        <div
            class="shrink-0 opacity-0 group-focus-within:opacity-100 group-hover:opacity-100 text-red"
        >
            <IconButton
                size="size-4"
                area-size="size-8"
                :aria-label="__('delete') + ' ' + filter.name"
                @click="$emit('delete', filter)"
            >
                <XIcon />
            </IconButton>
        </div>
    </div>
</template>
